import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    comp_id:"",
    comp_seq:"",
    comp_sort:"",
    comp_sort_detail:"",
    user_id:"",
    user_seq:"",
    user_name:"",
    user_nickname:"",
    corp_name:"",
    corp_seq:"",
    user_grade:"",
    main_user_seq:"",
    is_other_comp_login:"",
    stu_num_ciphers:"4",
    main_subject:"",
    is_use_coon_en:"",
    is_use_math:"",
    is_use_book_order:"",
    hmenuArr:[],
    smenuArr:[],
    tableKeyArr:{
      //"corp":["read","write","delete","update","list","display"],
    },
    sort_data:{},
    profile_url:"",
    profile_thum_url:"",
    logo_url:"",
  },
  reducers: {
    removeUser: (state:any) => {
      state.comp_id ="";
      state.comp_seq ="";
      state.comp_sort ="";
      state.comp_sort_detail ="";
      state.user_id ="";
      state.user_seq ="";
      state.user_name ="";
      state.user_nickname ="";
      state.user_grade ="";
      state.main_user_seq ="";
    },
    setUser: (state:any, action:any) => {
      for(let key in state){
        if(action.payload[key]!=undefined){
          state[key] =action.payload[key];
        }
      }
    }
  },
});

// Action creators are generated for each case reducer function
export const { removeUser,setUser } = userSlice.actions

export default userSlice.reducer